module.exports = __webpack_public_path__ + "static/media/ga-guide.08056f37.png";